import { ArithmeticSeriesWidgetConfig } from '../arithmetic-series.model';
import { ARITHMETIC_SERIES_EXPLORATION_PRESET } from './exploration.preset';

export interface ArithmeticSeriesPreset {
  id: string;
  title: string;
  description: string;
  config: ArithmeticSeriesWidgetConfig;
}

export const ARITHMETIC_SERIES_PRESETS = {
  exploration: ARITHMETIC_SERIES_EXPLORATION_PRESET,
} as const;

export type ArithmeticSeriesPresetId = keyof typeof ARITHMETIC_SERIES_PRESETS;
